import React from 'react'

const RADIUS = 50
const CIRCUMFERENCE = 2 * Math.PI * RADIUS

function ChatStatsRing({ percent, color, track, size = 84 }) {
    const safe = Math.max(0, Math.min(percent || 0, 100))
    const dash = (safe / 100) * CIRCUMFERENCE

    return (
        <svg width={size} height={size} viewBox="0 0 120 120">
            <circle cx="60" cy="60" r={RADIUS} fill="none" stroke={track} strokeWidth="14" />
            <circle
                cx="60"
                cy="60"
                r={RADIUS}
                fill="none"
                stroke={color}
                strokeWidth="14"
                strokeLinecap="round"
                strokeDasharray={`${dash} ${CIRCUMFERENCE}`}
                transform="rotate(-90 60 60)"
            />
            <text x="60" y="69" textAnchor="middle" fontSize="28" fontWeight="800" fill={color}>
                {Math.round(safe)}%
            </text>
        </svg>
    )
}

export default ChatStatsRing
